import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdatePromotion() {
    yield takeEvery(actions.CREATE_OR_UPDATE_PROMOTION_REQUESTED, function* (action) {
        try {
            const promotion = yield call(actions.createOrUpdatePromotion, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_PROMOTION_SUCCEEDED, promotion });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_PROMOTION_FAILED, error: error.response.data.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(createOrUpdatePromotion)
    ]);
}
